import { Text } from '@mantine/core';

import type { ResponseProjectBlock } from '../../../../../../../../../shared/entities/ResponseProjectBlock';

interface BlockTitleProps {
  depth: ResponseProjectBlock['depth'];
  title: string;
  isOpen: boolean;
}

export function BlockTitle({ depth, title, isOpen }: BlockTitleProps) {
  if (depth === 1) {
    return (
      <Text
        size="md"
        color={isOpen ? 'primary.7' : 'gray.9'}
        fw={isOpen ? 600 : 400}
        sx={{
          transition: 'all 0.2s ease-in-out',
        }}
      >
        {title}
      </Text>
    );
  }

  return (
    <Text size="sm" color={'gray.9'} fw={600}>
      {title}
    </Text>
  );
}
